module.exports = __webpack_public_path__ + "static/media/eml.5da7eb53.png";